export default __webpack_public_path__ + "static/1310-b1fc993eac9e97a4250d084d0a473595.gif";